
import {Component, Vue, Watch} from 'vue-property-decorator';
import {
  dispatchCreateInstitution, dispatchGetAddress,
  dispatchGetInstitution,
  dispatchUpdateInstitution,
} from '@/store/admin/actions';
import {
  readAddress,
  readInstitution
} from '@/store/admin/getters';
import {rules, stringToNumber} from '@/utils';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import RoleSettings from '@/components/extras/RoleSettings.vue';
import {dispatchGetUserProfile} from '@/store/main/actions';
import {IInstitution} from "@/interfaces/institution";
import FileUpload from "@/components/forms/FileUpload.vue";
import {get} from "@/helpers/api/utils";

@Component({
  methods: {get},
  components: {FileUpload, RoleSettings, DefaultHelp},
})
export default class CRUDInstitution extends Vue {
  private institution: IInstitution = {} as IInstitution;
  private rules: any = rules;

  private valid: boolean = false;
  private title: string = `${this.$t('crud.create')} ${this.$t('institution')}`;
  private institutionId: number = -1;

  private address: string = ''
  private searchedCep: string = ''

  public changeInstitutionalDoc(val) {
    this.institution.institutional_doc = val;
  }

  public changeResponsibleDoc(val) {
    this.institution.responsible_doc = val;
  }

  // @Watch('institution.cep')
  public async getCEP() {
    if (this.institution.cep.length !== 10) {
      return
    }

    if (this.searchedCep === this.institution.cep) {
      return
    }

    this.searchedCep = `${this.institution.cep}`

    await dispatchGetAddress(this.$store, this.institution.cep)
    const address = readAddress(this.$store)

    if (!address.logradouro) {
      return
    }

    this.address = `${address.logradouro}, ${address.bairro} - ${address.localidade}/${address.uf}`
  }


  public async mounted() {
    this.institutionId = this.$router.currentRoute.params.id as unknown as number;

    if (this.institutionId > 0) {
      await dispatchGetInstitution(this.$store, this.institutionId)
      this.title = `${this.$t('crud.update')} ${this.$t('institution')}`;
      this.institution = readInstitution(this.$store)(+this.institutionId) as IInstitution;
      this.address = `${this.institution.address}`

    } else {
      this.institution = {} as IInstitution;
      this.institutionId = 0;
    }

  }

  public beforeRouteLeave(to, from, next) {
    this.institution = {} as IInstitution;
    this.title = `${this.$t('crud.create')} ${this.$t('institution')}`;
    this.institutionId = 0;
    next();
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    this.institution = {} as IInstitution;
  }

  private async submit() {
    const form: any = this.$refs.form_crud_group;
    if (await form.validate()) {
      const institutionToSave = {
        ...this.institution,
        cep: stringToNumber(this.institution.cep),
        cnpj: stringToNumber(this.institution.cnpj),
        phone: stringToNumber(this.institution.phone),
        address: this.address,
        responsible_phone: stringToNumber(this.institution.responsible_phone)
      } as IInstitution

      if (this.institutionId > 0) {
        if (await dispatchUpdateInstitution(this.$store, institutionToSave)) {
          await dispatchGetUserProfile(this.$store);
          await this.$router.push({name: 'main-admin-institution-list'});
        }
      } else {
        if (await dispatchCreateInstitution(this.$store, institutionToSave)) {
          await this.$router.push({name: 'main-admin-institution-list'});
        }
      }
    }
  }


}
